import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  Inject,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { getKeyCode } from '@cigna/ui/utils';

export type DropdownValue = string | boolean | number | object;
export interface SelectionChange {
  option?: DropdownOptionComponent;
  value?: DropdownValue;
}

@Component({
  selector: 'cigna-dropdown-option',
  templateUrl: './dropdown-option.component.html',
  styleUrls: ['./dropdown-option.component.scss'],
})
export class DropdownOptionComponent {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public selected = false;
  @ViewChild('dropdownOption', { static: false }) dropdownOption: ElementRef;
  @Input() value: DropdownValue;
  @Input() collapsedText?: string;
  @Input() isDisabled?: boolean;
  @Output() readonly selectionChange = new EventEmitter<SelectionChange>();

  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private _element: ElementRef<HTMLElement>,
  ) {}

  get viewValue(): string {
    return this.collapsedText || (this.hostElement.textContent || '').trim();
  }
  get focused() {
    return this.dropdownOption.nativeElement === this._document.activeElement;
  }
  get hostElement(): HTMLElement {
    return this._element.nativeElement;
  }

  select(): void {
    if (!this.selected) {
      this.selected = true;
      this.emitSelectionChangeEvent();
    }
  }
  deselect(): void {
    this.selected = false;
  }
  focus(): void {
    this.dropdownOption.nativeElement.focus();
  }
  handleKeydown(event: KeyboardEvent): void {
    const keyCode = getKeyCode(event);
    if (keyCode === 'Enter' || keyCode === 'Space') {
      this.selectViaInteraction(event);
      event.preventDefault();
    }
  }
  selectViaInteraction(event: MouseEvent | KeyboardEvent): void {
    this.selected = true;
    this.emitSelectionChangeEvent();
    event.preventDefault();
    event.stopPropagation();
  }

  private emitSelectionChangeEvent(): void {
    this.selectionChange.emit({ option: this, value: this.value });
  }
}
